var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuelCardNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Fuel_card"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fuel_card",
    "data-name": "Fuel card",
    clipPath: "url(#clip-Fuel_card)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(1 3.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11761",
    "data-name": "Group 11761",
    transform: "translate(0 0.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22200",
    "data-name": "Path 22200",
    d: "M16.119,1.211a1.68,1.68,0,0,0-1.587-1.2Q8.094,0,1.655.007A1.672,1.672,0,0,0,0,1.661Q0,6.088,0,10.516a1.672,1.672,0,0,0,1.652,1.655q6.438,0,12.877,0a1.552,1.552,0,0,0,.7-.166,1.745,1.745,0,0,0,.943-1.236V1.408C16.156,1.342,16.139,1.276,16.119,1.211Zm-.643,9.251a.961.961,0,0,1-1.009,1q-3.2,0-6.39,0h0q-3.172,0-6.343,0a.979.979,0,0,1-1-.737,1.061,1.061,0,0,1-.025-.282q0-4.355,0-8.711A.961.961,0,0,1,1.72.716q6.375,0,12.75,0a.959.959,0,0,1,1.006,1Q15.479,6.09,15.476,10.462Z",
    transform: "translate(0 -0.005)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22201",
    "data-name": "Path 22201",
    d: "M383.54,255.27Z",
    transform: "translate(-367.365 -244.505)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22202",
    "data-name": "Path 22202",
    d: "M116.189,43.029l-.221-.326a.257.257,0,0,0-.209-.137h0a.257.257,0,0,0-.208.135q-.128.187-.254.375l-.109.161a.094.094,0,0,1-.02.022.059.059,0,0,1-.02-.022l-.016-.023q-.638-.946-1.277-1.893a.51.51,0,0,0-.123-.134l-.011-.008h-.159l-.01.005a.384.384,0,0,0-.132.131l-.382.566-.234.346-.593.88c-.388.575-.788,1.169-1.185,1.752a3.176,3.176,0,0,0-.565,2.107,3,3,0,0,0,.684,1.7,3.065,3.065,0,0,0,2.42,1.2,3.673,3.673,0,0,0,.737-.078,3.174,3.174,0,0,0,2.507-3.421.13.13,0,0,1,.04-.122,1.53,1.53,0,0,0,.186-1.969q-.422-.628-.846-1.255Zm-5.263,4.123a2.284,2.284,0,0,1-.037-.393v0a2.722,2.722,0,0,1,.472-1.608l2.248-3.328c.017-.025.026-.027.027-.027s.01,0,.027.027l.24.356c.311.461.632.938.951,1.4a.11.11,0,0,1,0,.157c-.1.135-.191.275-.281.411l-.1.146a1.545,1.545,0,0,0,1.856,2.3c.012,0,.04-.016.056-.02a.512.512,0,0,1,0,.054,2.724,2.724,0,0,1-.6,1.772,2.663,2.663,0,0,1-1.859,1.018,2.76,2.76,0,0,1-3-2.267Zm3.734-1.848a1.084,1.084,0,0,1,.186-.776q.3-.445.6-.889l.293-.433a.091.091,0,0,1,.018-.021.063.063,0,0,1,.021.023l.445.658.444.657a1.062,1.062,0,0,1,.2.6v.036a1.106,1.106,0,0,1-2.2.141Z",
    transform: "translate(-105.791 -39.444)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22203",
    "data-name": "Path 22203",
    d: "M140.881,135l-.055-.02-.04-.014a1.921,1.921,0,0,1-.94-2.836l.025-.037a.9.9,0,0,0,.059-.094.217.217,0,0,0-.072-.284.209.209,0,0,0-.282.038.675.675,0,0,0-.065.085,2.408,2.408,0,0,0-.412,1.425v0a2.3,2.3,0,0,0,.99,1.823,2.225,2.225,0,0,0,.647.327.3.3,0,0,0,.092.015.211.211,0,0,0,.208-.148.224.224,0,0,0-.155-.281Z",
    transform: "translate(-133.234 -126.121)",
    fill: "#0072ce"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelCardNew);
export default __webpack_public_path__ + "static/media/Fuel_card_New.75d16c27ae73e16c19ef5550f39942ce.svg";
export { ForwardRef as ReactComponent };